/** @jsx jsx */
import type { Interpolation } from '@emotion/react';
import { jsx } from '@emotion/react';

import * as React from 'react';

import { FormattedNumber } from 'js/lib/coursera.react-intl';

import type { Theme } from '@coursera/cds-core';
import { Typography2 } from '@coursera/cds-core';

import { truncToPlace } from 'bundles/primitive-formatting';

type Props = {
  grade?: number;
  cssOverride?: Interpolation<Theme>;
};

// Display a grade in percent view given the decimal value
const GradePercentDisplay = ({ grade, cssOverride }: Props) => {
  return (
    <Typography2 variant="subtitleMedium" component="span" css={cssOverride}>
      {grade == null ? (
        '--%'
      ) : (
        <FormattedNumber
          // eslint-disable-next-line react/style-prop-object
          style="percent"
          value={truncToPlace(grade, 4)}
          maximumFractionDigits={2}
        />
      )}
    </Typography2>
  );
};

export default GradePercentDisplay;
